import { Component } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import addComponentAnimation from '@swisslife/shared-ui/src/utils/animations/js/animations';

enum Selectors {
	Iframe = '.js-m-iframe__iframe',
}

// The @Component decorator will connect the class with `data-g-name="Iframe"` elements.
@Component('Iframe')
export class Iframe extends GondelJqueryComponent {
	private controllers: any[] = Array();

	public start() {
		this.writeDataSrcToSrc();
	}

	public async sync() {
		this.controllers = await addComponentAnimation(this.$ctx);
	}

	public stop() {
		for (const controller of this.controllers) {
			controller.destroy(true);
		}
	}

	private writeDataSrcToSrc() {
		// this is necessary to prevent iframe from loading content before cookie consent is given
		// (compare onetrust-wrapper)
		const iframe = this.$ctx.find(`${Selectors.Iframe}`);
		const dataSrcValue = iframe.attr(`data-src`);
		if (dataSrcValue) {
			iframe.attr('src', dataSrcValue);
		}
	}
}
